import { render, staticRenderFns } from "./ControladorForm.vue?vue&type=template&id=1aa0cba2"
import script from "./ControladorForm.vue?vue&type=script&lang=js"
export * from "./ControladorForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports